import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../firebase';

export function useHeartbeat() {
    const location = useLocation();

    useEffect(() => {
        // Only run if user is logged in
        const currentUser = auth.currentUser;
        if (!currentUser) return;

        const updatePresence = async () => {
            try {
                const userRef = doc(db, 'users', currentUser.uid);
                await updateDoc(userRef, {
                    lastActiveAt: serverTimestamp(),
                    lastActiveRoute: location.pathname
                });
            } catch (err) {
                // minor failure ok
                console.warn('Presence update failed', err);
            }
        };

        // Update on mount and route change
        updatePresence();

        // Update every 60s
        const interval = setInterval(updatePresence, 60000);

        return () => clearInterval(interval);
    }, [location.pathname]);
}
